import { Box, Typography, Divider, Paper } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import AppBreadcrumbs from "../../components/shared/Breadcrumbs/AppBreadcrumbs";
import PageHeader from "../../components/shared/PageHeader/PageHeader";

import { getNewsBySlug } from "../../api/news";
import { useLanguage } from "../../context/LanguageContext";

const NewsDetails = () => {
  const { newsId } = useParams(); // slug
  const { language } = useLanguage();
  const navigate = useNavigate();

  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!newsId) return;

    getNewsBySlug(newsId, language)
      .then((news) => {
        if (!news) return;

        setPageData({
          breadcrumb: news.title,
          title: news.title,
          description: news.shortDesc,
          date: news.date,
          fullDesc: news.fullDesc,
        });
      })
      .catch((error) => {
        console.error("News details error:", error);
      })
      .finally(() => setLoading(false));
  }, [newsId, language]);

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: "center" }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!pageData) {
    return (
      <Box sx={{ py: 6, textAlign: "center" }}>
        <Typography variant="h6">News not found</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 6 }}>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <AppBreadcrumbs
          items={[
            { label: "Home", path: "/" },
            { label: "About CDMP 2026", path: "/cdmp/documents" },
            { label: pageData.breadcrumb },
          ]}
        />
      </Box>

      {/* Page Header */}
      <PageHeader
        title={pageData.title}
        description={pageData.description}
      />

      {/* Content */}
      <Paper
        elevation={0}
        sx={{
          mt: 4,
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          maxWidth: 1000,
        }}
      >
        <Typography color="text.secondary" mb={3}>
          {new Date(pageData.date).toLocaleDateString(
            language === "mr" ? "mr-IN" : "en-IN",
            {
              day: "numeric",
              month: "long",
              year: "numeric",
            }
          )}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Typography sx={{ lineHeight: 1.8 }}>
          {pageData.fullDesc}
        </Typography>
      </Paper>
    </Box>
  );
};

export default NewsDetails;
